// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { EventKey, EventKeyT } from "../mce/event-key";
import { Template, TemplateT, verifyTemplate } from "../mce/template";

/**
 * POST (create) or PUT (create or update) the class of one event.
 */
export class MceEventClassSet implements flatbuffers.IUnpackableObject<MceEventClassSetT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): MceEventClassSet {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMceEventClassSet(
    bb: flatbuffers.ByteBuffer,
    obj?: MceEventClassSet,
  ): MceEventClassSet {
    return (obj || new MceEventClassSet()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsMceEventClassSet(
    bb: flatbuffers.ByteBuffer,
    obj?: MceEventClassSet,
  ): MceEventClassSet {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new MceEventClassSet()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  key(obj?: EventKey): EventKey | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? (obj || new EventKey()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  template(obj?: Template): Template | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Template()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  note(): string | null;
  note(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  note(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startMceEventClassSet(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addKey(builder: flatbuffers.Builder, keyOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, keyOffset, 0);
  }

  static addTemplate(builder: flatbuffers.Builder, templateOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, templateOffset, 0);
  }

  static addNote(builder: flatbuffers.Builder, noteOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, noteOffset, 0);
  }

  static endMceEventClassSet(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // key
    builder.requiredField(offset, 6); // template
    return offset;
  }

  unpack(): MceEventClassSetT {
    return new MceEventClassSetT(
      this.key() !== null ? this.key()!.unpack() : null,
      this.template() !== null ? this.template()!.unpack() : null,
      this.note(),
    );
  }

  unpackTo(_o: MceEventClassSetT): void {
    _o.key = this.key() !== null ? this.key()!.unpack() : null;
    _o.template = this.template() !== null ? this.template()!.unpack() : null;
    _o.note = this.note();
  }

  unpackFields(...fields: string[]): MceEventClassSetT {
    const t = new MceEventClassSetT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("key")) {
      t.key = this.key() !== null ? this.key()!.unpack() : null;
    }
    if (fieldSet.has("template")) {
      t.template = this.template() !== null ? this.template()!.unpack() : null;
    }
    if (fieldSet.has("note")) {
      t.note = this.note();
    }
    return t;
  }
}

export class MceEventClassSetT implements flatbuffers.IGeneratedObject {
  constructor(
    public key: EventKeyT | null = null,
    public template: TemplateT | null = null,
    public note: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.key === null || this.key === undefined) {
      throw new Error('Required field "key" is not set');
    }
    if (this.template === null || this.template === undefined) {
      throw new Error('Required field "template" is not set');
    }
    const template = this.template !== null ? this.template!.pack(builder) : 0;
    const note = this.note !== null ? builder.createString(this.note!) : 0;

    MceEventClassSet.startMceEventClassSet(builder);
    MceEventClassSet.addKey(builder, this.key !== null ? this.key!.pack(builder) : 0);
    MceEventClassSet.addTemplate(builder, template);
    MceEventClassSet.addNote(builder, note);

    return MceEventClassSet.endMceEventClassSet(builder);
  }

  clone(): MceEventClassSetT {
    const obj = new MceEventClassSetT();
    obj.key = this.key !== null ? this.key!.clone() : null;
    obj.template = this.template !== null ? this.template!.clone() : null;
    obj.note = this.note;
    return obj;
  }

  equals(other: MceEventClassSetT): boolean {
    if (this.key !== null && other.key !== null) {
      if (!this.key!.equals(other.key!)) return false;
    } else if (this.key !== other.key) return false;
    if (this.template !== null && other.template !== null) {
      if (!this.template!.equals(other.template!)) return false;
    } else if (this.template !== other.template) return false;
    if (this.note !== other.note) return false;
    return true;
  }
}

export function verifyMceEventClassSet(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 8);
    verifier.checkRequiredField(tablePos, 4, "key");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyTemplate(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "template");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
